import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgHeartFill = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572z" }));
const ForwardRef = forwardRef(SvgHeartFill);
export default ForwardRef;
